export default function LlamaIcon(props) {
  const { width = 16, height = 16 } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width={width}
        height={height}
        rx="2"
        fill="white"
      />
      <path
        d="M6.16093 4C6.15739 4 6.15387 4.00001 6.15033 4.00003L6.13587 5.14419C6.13918 5.14416 6.14249 5.14413 6.1458 5.14413C6.93224 5.14413 7.54225 5.73792 8.8681 7.87652L8.94893 8.00672L8.95421 8.01524L9.69641 6.94885L9.69127 6.94061C9.51661 6.66857 9.3488 6.41827 9.18787 6.18973C9.00123 5.92492 8.82274 5.68835 8.64953 5.47714C7.77243 4.40772 7.03873 4 6.16093 4Z"
        fill="url(#paint0_linear_584_3992)"
      />
      <path
        d="M6.15033 4.00003C5.26827 4.00438 4.48839 4.55057 3.9253 5.38637C3.92365 5.38881 3.922 5.39126 3.92036 5.39372L4.95397 5.93245C4.95565 5.93001 4.95733 5.92758 4.95902 5.92515C5.28783 5.45107 5.69709 5.14869 6.13587 5.14419C6.13918 5.14416 6.14249 5.14413 6.1458 5.14413L6.16093 4C6.15739 4 6.15387 4.00001 6.15033 4.00003Z"
        fill="url(#paint1_linear_584_3992)"
      />
      <path
        d="M3.9253 5.38637C3.92365 5.38881 3.922 5.39126 3.92036 5.39372C3.55035 5.94528 3.27445 6.62279 3.12538 7.35297C3.12474 7.35613 3.1241 7.35929 3.12345 7.36246L4.28467 7.62483C4.28528 7.62166 4.28589 7.61849 4.2865 7.61532C4.41063 6.97361 4.647 6.37779 4.95397 5.93245C4.95565 5.93001 4.95733 5.92758 4.95902 5.92515L3.9253 5.38637Z"
        fill="url(#paint2_linear_584_3992)"
      />
      <path
        d="M4.2865 7.61532L3.12538 7.35297C3.12474 7.35613 3.1241 7.35929 3.12345 7.36246C3.04217 7.76403 3.00088 8.17244 3.00001 8.58148C3 8.58479 3 8.5881 3 8.5914L4.19088 8.69342C4.19079 8.6901 4.19069 8.68682 4.19061 8.6835C4.19002 8.65977 4.18972 8.63573 4.18971 8.61136C4.19031 8.28056 4.22204 7.95014 4.28467 7.62483C4.28528 7.62166 4.28589 7.61849 4.2865 7.61532Z"
        fill="url(#paint3_linear_584_3992)"
      />
      <path
        d="M4.2271 9.04764C4.20574 8.93008 4.19363 8.81114 4.19088 8.69184C4.19079 8.68853 4.19069 8.68525 4.19061 8.68191L3.00001 8.5799C3 8.58321 3 8.58652 3 8.58982C3 8.8444 3.02217 9.0834 3.06526 9.30359C3.06588 9.30678 3.06649 9.3099 3.06712 9.31308L4.2289 9.05716C4.22829 9.054 4.22769 9.05082 4.2271 9.04764Z"
        fill="url(#paint4_linear_584_3992)"
      />
      <path
        d="M4.49839 9.63928C4.36881 9.50383 4.2771 9.30845 4.22888 9.05857C4.22827 9.05541 4.22768 9.05223 4.22708 9.04905L3.06523 9.30499C3.06586 9.30818 3.06647 9.31131 3.0671 9.31449C3.15492 9.75601 3.32714 10.124 3.57378 10.4024C3.57597 10.4048 3.57817 10.4073 3.58038 10.4098L4.50532 9.64641C4.50301 9.64405 4.50068 9.64167 4.49839 9.63928Z"
        fill="url(#paint5_linear_584_3992)"
      />
      <path
        d="M7.94046 6.47353C7.24033 7.50189 6.8162 8.14689 6.8162 8.14689C5.88356 9.54689 5.56092 9.86066 5.04167 9.86066C4.825 9.86066 4.64399 9.78763 4.50532 9.64641C4.50301 9.64405 4.50068 9.64167 4.49839 9.63928L3.57378 10.4024C3.57597 10.4048 3.57817 10.4073 3.58038 10.4098C3.92093 10.7899 4.40163 11 4.9963 11C5.89599 11 6.54307 10.5938 7.69338 8.66827C7.69338 8.66827 8.1729 7.85737 8.50278 7.2988C8.29844 6.98286 8.11248 6.70936 7.94046 6.47353Z"
        fill="#0082FB"
      />
      <path
        d="M9.18841 4.85125C9.18605 4.85365 9.18364 4.8561 9.18129 4.85851C8.99743 5.04609 8.82118 5.25488 8.64953 5.47714C8.82275 5.68836 9.00136 5.92607 9.18801 6.19088C9.40798 5.86575 9.61332 5.60243 9.81457 5.4006C9.81696 5.39821 9.81929 5.39589 9.82168 5.3935L9.18841 4.85125Z"
        fill="url(#paint6_linear_584_3992)"
      />
      <path
        d="M12.5875 4.74954C12.0992 4.27717 11.517 4 10.8947 4C10.2384 4 9.68632 4.3453 9.18841 4.85125C9.18605 4.85365 9.18364 4.8561 9.18129 4.85851L9.81457 5.4006C9.81696 5.39821 9.81929 5.39589 9.82168 5.3935C10.1497 5.06678 10.4672 4.90275 10.8191 4.90275C11.1979 4.90275 11.5524 5.07349 11.8594 5.37281C11.8618 5.37515 11.8642 5.37748 11.8666 5.37984L12.5947 4.75657C12.5923 4.75421 12.5899 4.75188 12.5875 4.74954Z"
        fill="#0082FB"
      />
      <path
        d="M13.999 8.4296C13.9716 6.91291 13.4174 5.55729 12.5947 4.75657C12.5923 4.75421 12.5899 4.75188 12.5875 4.74954L11.8594 5.37281C11.8618 5.37515 11.8642 5.37748 11.8666 5.37984C12.4855 5.98862 12.91 7.12069 12.9486 8.42927C12.9487 8.43257 12.9488 8.43586 12.9489 8.43915L13.9991 8.43947C13.9991 8.43619 13.9991 8.43289 13.999 8.4296Z"
        fill="url(#paint7_linear_584_3992)"
      />
      <path
        d="M13.9991 8.44053C13.9991 8.43724 13.9991 8.43394 13.999 8.43064L12.9486 8.43032C12.9487 8.43362 12.9488 8.43691 12.9489 8.4402C12.9506 8.50163 12.9514 8.56342 12.9514 8.62558C12.9514 8.98236 12.8958 9.27077 12.7826 9.47899C12.7809 9.48208 12.7792 9.48518 12.7775 9.48823L13.5606 10.2682C13.5626 10.2654 13.5645 10.2626 13.5665 10.2597C13.8507 9.83961 14 9.25602 14 8.54834C14 8.51231 13.9997 8.47637 13.9991 8.44053Z"
        fill="url(#paint8_linear_584_3992)"
      />
      <path
        d="M12.7827 9.4774C12.781 9.48048 12.7793 9.48358 12.7776 9.48663C12.6797 9.66215 12.5399 9.77921 12.3571 9.8304L12.7141 10.9078C12.7614 10.8925 12.8074 10.8752 12.8522 10.8561C12.8656 10.8504 12.8789 10.8445 12.892 10.8385C12.8996 10.835 12.9072 10.8314 12.9147 10.8279C13.1507 10.7152 13.3502 10.549 13.5116 10.3349C13.5215 10.3218 13.5312 10.3087 13.5407 10.2952C13.5475 10.2858 13.5542 10.2762 13.5607 10.2666C13.5627 10.2638 13.5646 10.2609 13.5665 10.2581L12.7827 9.4774Z"
        fill="url(#paint9_linear_584_3992)"
      />
      <path
        d="M12.1297 9.85961C12.01 9.85961 11.9043 9.84254 11.8009 9.79831L11.4354 10.9014C11.6409 10.9686 11.8601 10.9989 12.1045 10.9989C12.3297 10.9989 12.5364 10.9667 12.7238 10.9044L12.3669 9.82735C12.29 9.84943 12.21 9.8603 12.1297 9.85961Z"
        fill="url(#paint10_linear_584_3992)"
      />
      <path
        d="M11.3982 9.48354C11.396 9.48106 11.3937 9.47856 11.3914 9.47603L10.5503 10.3137C10.5527 10.3162 10.555 10.3186 10.5573 10.321C10.8496 10.6192 11.1287 10.8042 11.4452 10.9058L11.8105 9.8035C11.6771 9.74865 11.5481 9.6492 11.3982 9.48354Z"
        fill="url(#paint11_linear_584_3992)"
      />
      <path
        d="M11.3914 9.47603C11.1391 9.19507 10.8271 8.72644 10.3362 7.96998L9.69641 6.94885L9.69127 6.94061L8.94893 8.00672L8.95421 8.01524L9.40747 8.74485C9.8469 9.44901 10.2048 9.95926 10.5503 10.3137C10.5527 10.3162 10.555 10.3186 10.5573 10.321L11.3982 9.48354C11.396 9.48106 11.3937 9.47856 11.3914 9.47603Z"
        fill="url(#paint12_linear_584_3992)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_584_3992"
          x1="12.4759"
          y1="10.244"
          x2="9.46953"
          y2="2.95394"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0006"
            stop-color="#0867DF"
          />
          <stop
            offset="0.4539"
            stop-color="#0668E1"
          />
          <stop
            offset="0.8591"
            stop-color="#0064E0"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_584_3992"
          x1="5.38365"
          y1="9.7183"
          x2="11.4516"
          y2="3.19805"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.1323"
            stop-color="#0064DF"
          />
          <stop
            offset="0.9988"
            stop-color="#0064E0"
          />
        </linearGradient>
        <linearGradient
          id="paint2_linear_584_3992"
          x1="6.39392"
          y1="10.2389"
          x2="7.52406"
          y2="4.54719"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0147"
            stop-color="#0072EC"
          />
          <stop
            offset="0.6881"
            stop-color="#0064DF"
          />
        </linearGradient>
        <linearGradient
          id="paint3_linear_584_3992"
          x1="8.11122"
          y1="10.3133"
          x2="8.34153"
          y2="5.08275"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0731"
            stop-color="#007CF6"
          />
          <stop
            offset="0.9943"
            stop-color="#0072EC"
          />
        </linearGradient>
        <linearGradient
          id="paint4_linear_584_3992"
          x1="8.73705"
          y1="8.98742"
          x2="8.21369"
          y2="5.17423"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0731"
            stop-color="#007FF9"
          />
          <stop
            offset="1"
            stop-color="#007CF6"
          />
        </linearGradient>
        <linearGradient
          id="paint5_linear_584_3992"
          x1="7.14579"
          y1="4.82123"
          x2="8.38826"
          y2="8.90733"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0731"
            stop-color="#007FF9"
          />
          <stop
            offset="1"
            stop-color="#0082FB"
          />
        </linearGradient>
        <linearGradient
          id="paint6_linear_584_3992"
          x1="6.10523"
          y1="8.82012"
          x2="7.7399"
          y2="4.58072"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.2799"
            stop-color="#007FF8"
          />
          <stop
            offset="0.9141"
            stop-color="#0082FB"
          />
        </linearGradient>
        <linearGradient
          id="paint7_linear_584_3992"
          x1="6.26001"
          y1="4.43644"
          x2="6.92024"
          y2="11.3099"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0082FB" />
          <stop
            offset="0.9995"
            stop-color="#0081FA"
          />
        </linearGradient>
        <linearGradient
          id="paint8_linear_584_3992"
          x1="11.2438"
          y1="4.32625"
          x2="10.1613"
          y2="9.72258"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0619"
            stop-color="#0081FA"
          />
          <stop
            offset="1"
            stop-color="#0080F9"
          />
        </linearGradient>
        <linearGradient
          id="paint9_linear_584_3992"
          x1="5.16971"
          y1="8.15238"
          x2="7.94115"
          y2="4.48866"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#027AF3" />
          <stop
            offset="1"
            stop-color="#0080F9"
          />
        </linearGradient>
        <linearGradient
          id="paint10_linear_584_3992"
          x1="5.24767"
          y1="7.50006"
          x2="12.0323"
          y2="7.50006"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0377EF" />
          <stop
            offset="0.9994"
            stop-color="#0279F1"
          />
        </linearGradient>
        <linearGradient
          id="paint11_linear_584_3992"
          x1="6.99308"
          y1="6.47089"
          x2="10.0448"
          y2="9.81354"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.0019"
            stop-color="#0471E9"
          />
          <stop
            offset="1"
            stop-color="#0377EF"
          />
        </linearGradient>
        <linearGradient
          id="paint12_linear_584_3992"
          x1="9.26467"
          y1="7.60647"
          x2="10.9987"
          y2="9.88321"
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset="0.2765"
            stop-color="#0867DF"
          />
          <stop
            offset="1"
            stop-color="#0471E9"
          />
        </linearGradient>
      </defs>
    </svg>
  );
}
